import React, { useState } from "react";
import styles from "../../../styles/pages/approvals.module.scss";
import Icons from "../../../public/assets/svg";

import { useRouter } from "next/router";
import axios from "axios";
import BasicForm from "../../basicForm";
import BasicForm3 from "../../BasicForm3";
import endpoints from "../../../utility/endpoints";
import Loader from "../../Loader";
import _get from "lodash/get";
import MobileFilters from "../../MobileFilters";
import { useMediaQuery } from "react-responsive";
import Fuse from "fuse.js";
//import Pagination from '../../Pagination'
import Pagination from "../../PaginationDemand";
import {
  sessionTimeOutCheck,
  checkExpiry,
} from "../../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

function index(props) {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const intialOffset = 0;
  const [offset, setOffset] = useState(intialOffset);
  const [filterOn, setFilterOn] = useState(false);
  //console.log("Props approval druple data-----", props.data);
  //props.data[0].component.content.field_approvals_component[0].field_options
  // console.log("zerodata -",props.data[1].component.content)
  //console.log("Props approval -----", props);
  //console.log("zerodata -", props.data[1].component.content)
  const [searchKeyword, setsearchKeyword] = useState("");
  // const filterDrupalData = props.data[0].component.content.field_approvals_component[0].field_demand_table_filters
  //  console.log("props global data ----", props.globalData);
  props.globalData.cluster_main_component[0].field_related_dropdown = "";
const landscapData = 
    {
      "field_form_field_title": "Landscape",
      "field_label": "Landscape",
      "field_input_type": "Dropdown",
      "field_related_dropdown": null,
      "field_options": [
        "Cordillera",
        "Fusion",
        "Global",
        "Sirius",
        "U2K2"
      ],
      "field_input": "Select Landscape",
      "field_message_ip_error_message": "Landscape is mandatory",
      "field_required": "0",
      "field_dropdown_option_component": [
          {
              "field_title": "",
              "field_options": []
          }
      ],
      "field_editable": "",
      "field_column_size": ""
  };
  const [filterDropdowns,setFiltersDropdowns] = useState([ 
    props.globalData.cluster_main_component[0],
    props.globalData.lead_platform_main_component[0],
    props.globalData.lead_platform_main_component[1],
    props.globalData.lead_platform_main_component[2] 
  ]);
  const router = useRouter();

  const [clearDropDown, setClearDropdown] = useState(false);
  const [modalactive, setmodalactive] = useState(false);

  const [botState, setBotState] = useState([]);

  const [loader, setloader] = useState(false);
  const [noResultImage, setNoResultImage] = useState(false);

  const [filterState, setFilterState] = React.useState({
    kfa: true,
  });
  const [length, setLength] = useState(0);
  const [submitForm, setSubmitForm] = React.useState(false);
  const [emptyFormValues, setEmptyFormValues] = React.useState(false);
  const [auth, setAuth] = useState("");
  const [gfcfSeleted, setGfcfSeleted] = useState(false);
  const [reset, setreset] = useState(false);
  const [filterActive, setFilterActive] = React.useState(false);
  const [readMoreState, setReadMoreState] = React.useState({});
  const [paginationNum, setPaginationNum] = useState(1);
  const [botCount, setBotCount] = useState(0);
  const [mobileFilterRelatedInfo, setMobileFilterRelatedInfo] = React.useState(
    {}
  );
  // "businessOwnerAutomatic",
  // "internalUser",
  //"supportStatus",
  // "editAccess",
  const [nonApprovers, setNonApprovers] = useState(["admin", "internalUser", "qrManager", "supportStatus", "releaseManager"]);
  const [approvers, setApprovers] = useState([
    "gCad",
    "firstLevelGPMApprover",
    "GPMapprover",
    "firstGfcf",
    "gfcf",
    "businessOwner",
    "landscape",
    "infosec"
  ]);
  React.useEffect(async () => {
    await getBotsForApproval();

    //console.log("Filter  ----", filterState);
    //console.log("Offset ", offset);
  }, [filterState, offset]);

  React.useEffect(() => {
    paginationNum >= 1 && setOffset((paginationNum - 1) * 5);
  }, [paginationNum]);

  const [searchApproval, setsearchApproval] = useState("");

  const getBotsForApproval = async (kfaOffset) => {
    //console.log('search keyword', searchKeyword);
    try {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      setAuth(auth);
      // console.log("get botss approval----------");
      //console.log("filter state  ---for api--- ", filterState);
      let filter = filterState;
      if (auth.userType == "businessUserRegionWise") {
        delete filter.kfa
        
      } else if (auth.userType == "businessOwner") {
        delete filter.kfa
        filter.businessOwnerEmailID = auth.email;
      } 
      else if (auth.userType == "firstLevelGPMApprover" || auth.userType == "GPMapprover") {
        delete filter.kfa
      }
	else if (auth.userType == "landscape") {
    if(filter.landscapeId == ""){
      delete filter.landscapeId
    }
        delete filter.kfa
        filter.landscape = true;
        filter.offset = 0;
    }
      else if (auth.userType == "infosec") {
        delete filter.kfa
        filter.infosec = true;
        filter.offset = 0;
      }
      //console.log("filter ---object", filter);
      if (kfaOffset != undefined) {
        filter.offset = kfaOffset;
      } else {
        filter.offset = offset;
      }

      //console.log("Final Filter --", filter);
      //console.log("search apporval", searchApproval);
      //console.log(filter, "filter before")
      setloader(true);
      //console.log("Filter  before api ---", filter);

      //console.log("OFF SET  ---", offset);
      //console.log("Filter  -----", filter);

      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        axios({
          method: "get",
          url: `${endpoints.baseUrl}/bot/getBotsForApproval`,
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
          params: filter,
        }).then((response) => {
          if (response.data.code == 403) {
            setloader(false);
            localStorage.removeItem("auth");
            sessionStorage.clear();
            props.sessionTimeOutCheck(true);
          }
          if (response.data.code == 200) {
            setloader(false);
            //console.log("response  ---", response.data.data);
            if (response.data.data.rows.length == 0) {
              //console.log("empty response  --", response.data.data.rows.length);
              setNoResultImage(true);
            } else {
              console.log("No reslut image");
              setNoResultImage(false);
            }
            setBotCount(response.data.data.count);
            setBotState(response.data.data.rows);
          }
        });
      } else {
        props.sessionTimeOutCheck(true);
        setloader(false)
      }
    } catch (e) {
      setloader(false);
      console.log("error", e);
    }
  };

  // revice filtre from drop dowm
  const recievedFormValues = async (formState) => {
    //console.log("form state  ----", formState);
    //console.log("form state", formState);
    let filter = formState;
    for (let i in filter) {
      if (filter[i] == "") {
        delete filter[i];
      }
    }
    //console.log("fromdromdown", filterState);
    let landscapeId=''
    if(formState.landscape=='Global'){landscapeId='0';}
    if(formState.landscape=='Fusion'){landscapeId='1';}
    if(formState.landscape=='Sirius'){landscapeId='2';}
    if(formState.landscape=='Cordillera'){landscapeId='3';}
    if(formState.landscape=='U2K2'){landscapeId='4';}
    let obje={...filter}
    obje.kfa=filterState.kfa
    obje.gpm=filterState.gpm
    obje.infosec=filterState.infosec
    obje.landscape=filterState.landscape
    if (formState.landscape!==""){
      obje.landscapeId=landscapeId
    }
    setFilterState({...obje});
    setPaginationNum(1);
  };

  const searchInTable = (e) => {
    setsearchKeyword(e.target.value);
    //console.log("Search parameter", e.target.value);
    if (e.target.value.length >= 3) {
      setOffset(0);
      let filter = filterState;
      filter.search = e.target.value;
      //console.log("FIter ---", filter);
      setFilterState({ ...filter });
      setPaginationNum(1);
    } else {
      let filter = filterState;
      if (Object.keys(filter).includes("search")) {
        delete filter.search;
        setFilterState({ ...filter });
      }
    }
  };

  // export all bots
  const exportAllBot = async () => {
    //console.log("Inside Export ALl Bots ");
    try {
      //console.log("get botss approval----------");
      //console.log("filter state  ---for api ", filterState);
      let filter = filterState;
      if (auth.userType == "businessUserRegionWise") {
        filter.mco = auth.personalMco;
        filter.cluster = auth.personalCluster;
      } else if (auth.userType == "businessOwner") {
        filter.businessOwnerEmailID = auth.email;
      }
      //console.log("filter ---object", filter);

      setloader(true);
      let authCheck = await JSON.parse(localStorage.getItem("auth")).data;

      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        
      
      const getBotUsingExcel = await axios({
        method: "GET",
        url: `${endpoints.baseUrl}/bot/getBotsInExcelApprover`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
        params: filter,
      });
      if (getBotUsingExcel.data.code == 200) {
        //console.log("get bot using excel", getBotUsingExcel);
        setloader(false);
        window.open(getBotUsingExcel.data.data);
      }
      setloader(false);
      //console.log("get bot using excel response  ---", getBotUsingExcel);
      if (getBotUsingExcel.data.code == 403) {
        setloader(false);
        localStorage.removeItem("auth");
        sessionStorage.clear();
        props.sessionTimeOutCheck(true);
      }
    }
    else {
      setloader(false);
      props.sessionTimeOutCheck(true)
    }
    } catch (e) {
      setloader(false);
      console.log("error ---", e);
    }
  };
 const handleKfaButton = async (e) => {
    //console.log("id ---", e.target.id);
    setOffset(0);
    setPaginationNum(1);
    if (e.target.id == "gfcf") {
      // setGfcfSeleted(!gfcfSeleted);
      let filterGfcf = filterState;
      filterGfcf.kfa = true;
      filterGfcf.offset = 0;
      if (Object.keys(filterGfcf).includes("gpm")||Object.keys(filterGfcf).includes("infosec")||Object.keys(filterGfcf).includes("landscape")) {
        delete filterGfcf["gpm"];
        delete filterGfcf["infosec"];
        delete filterGfcf["landscape"];
        delete filterGfcf["landscapeId"];
      }
      //console.log("filter state --", filterGfcf);
      setFilterState({ ...filterGfcf });
      //console.log("gfcf ---", gfcfSeleted);
      // await getBotsForApproval();
    }else if (e.target.id == "infosec") {
      // setGfcfSeleted(!gfcfSeleted);
      let filterGfcf = filterState;
      filterGfcf.infosec = true;
      filterGfcf.offset = 0;
      if (Object.keys(filterGfcf).includes("gpm")||Object.keys(filterGfcf).includes("kfa")||Object.keys(filterGfcf).includes("landscape")) {
        delete filterGfcf["gpm"];
        delete filterGfcf["kfa"];
        delete filterGfcf["landscape"];
        delete filterGfcf["landscapeId"];

      }
      //console.log("filter state --", filterGfcf);
      setFilterState({ ...filterGfcf });
      //console.log("gfcf ---", gfcfSeleted);
      // await getBotsForApproval();
    } else if (e.target.id == "landscape") {
      // setGfcfSeleted(!gfcfSeleted);
      let filterGfcf = filterState;
      filterGfcf.landscape = true;
      filterGfcf.offset = 0;
      if (Object.keys(filterGfcf).includes("gpm")||Object.keys(filterGfcf).includes("infosec")||Object.keys(filterGfcf).includes("kfa")) {
        delete filterGfcf["gpm"];
        delete filterGfcf["kfa"];
        delete filterGfcf["infosec"];
      }
      //console.log("filter state --", filterGfcf);
      // setFilterState(filterGfcf);
      setFilterState({ ...filterGfcf });

      //console.log("gfcf ---", gfcfSeleted);
      // await getBotsForApproval();
    }
     else {
      // setGfcfSeleted(false);
      let filterValues = filterState;
      if (Object.keys(filterValues).includes("kfa")||Object.keys(filterValues).includes("infosec")||Object.keys(filterValues).includes("landscape")) {
        delete filterValues["kfa"];
        delete filterValues["infosec"];
        delete filterValues["landscape"];
        delete filterValues["landscapeId"];

      }
      filterValues.gpm = true;
      filterValues.offset = 0;
      //console.log("on gpm ---", filterValues);
      setFilterState(filterValues);
      await getBotsForApproval(0);
    }
  };

  const convertToDDMMYYYY = (date) => {
    if (date === undefined || date == null || date == "" || date == "undefined" || date == "NA") {
      return "--";
    } else {
      let year = date.slice(0, 4);
      let month = date.slice(5, 7);
      let day = date.slice(8, 10);

      let newDate = day + "-" + month + "-" + year;
      return newDate;
    }
  };
  const getLandscapeById =(id)=>{
    if(id=='0'){
      return 'Global';
      }
    if(id=='1'){
      return 'Fusion';
      }
    if(id=='2'){
      return 'Sirius';
      }
    if(id=='3'){
      return 'Cordillera';
      }
    if(id=='4'){
      return 'U2K2';
      }
  }

  return (
    <div className={styles.containerApproval}>
      {nonApprovers.includes(auth.userType) && (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className={styles.buttonstwins}>
                <span
                  className={
                    filterState.kfa ? styles.onebtn : styles.onebtnInactive
                  }
                  onClick={handleKfaButton}
                  id="gfcf"
                >
                  {_get(
                    props,
                    "data[0].component.content.field_options[0]",
                    ""
                  )}
                </span>
                <span
                  className={
                    filterState.gpm ? styles.twobtn : styles.twobtnInactive
                  }
                  onClick={handleKfaButton}
                  id="gpm"
                >
                  {_get(
                    props,
                    "data[0].component.content.field_options[1]",
                    ""
                  )}
                </span>
                <span
                  className={
                    filterState.infosec ? styles.onebtn : styles.onebtnInactive
                  }
                  onClick={handleKfaButton}
                  id="infosec"
                >
                  {_get(
                    props,
                    "data[0].component.content.field_options[2]",
                    ""
                  )}
                </span>
                <span
                  className={
                    filterState.landscape ? styles.twobtn : styles.twobtnInactive
                  }
                  onClick={handleKfaButton}
                  id="landscape"
                >
                  {_get(
                    props,
                    "data[0].component.content.field_options[3]",
                    ""
                  )}
                </span> 
	     </div>
            </div>
          </div>
        </div>
      )}
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className={styles.demandActionHead}>
              <div className={styles.top}>
                <div className={styles.left}>
                  <div className={styles.search} onChange={searchInTable}>
                    <Icons
                      name="searchGrayIcon"
                      className={styles.searchIcon}
                    />
                    <input
                      type="text"
                      onChange={searchInTable}
                      placeholder={_get(
                        props,
                        "data[0].component.content.field_search_placeholder",
                        ""
                      )}
                      value={searchKeyword != "" ? searchKeyword : ""}
                    />
                  </div>
                </div>
                <div className={styles.right}>
                  <div className={styles.combinedBtn}>
                    <span
                      className={styles.rowBtn}
                      onClick={() => {
                        setFilterState({});
                        setreset(true);
                        setsearchKeyword("");
                        setPaginationNum(1);
                      }}
                    >
                      {_get(
                        props,
                        "data[0].component.content.field_button_text[0]",
                        ""
                      )}
                    </span>
                  
                      <span
                        className={styles.exportListBtn}
                        onClick={exportAllBot}
                      >
                        <Icons
                          name="uploadicon"
                          className={styles.uploadIcon}
                        ></Icons>
                        {_get(
                          props,
                          "data[0].component.content.field_button_text[1]",
                          ""
                        )}
                      </span>
                   
                  </div>
                </div>
              </div>
              <div className={styles.bottom}>
                <BasicForm
                  data={filterDropdowns}
                  params="approval"
                  sendFormValues={recievedFormValues}
                  emptyFormValues={emptyFormValues}
                  reset={reset}
                  setreset={setreset}
                  notRequired={[]}
                  // setClearDropdown={setClearDropdown}
                />
                {auth.userType == "admin" &&
		            <BasicForm3
                  data={[landscapData]}
                  params="approval"
                  notRequired={[]}
                  sendFormValues={recievedFormValues}
                  emptyFormValues={emptyFormValues}
                  reset={reset}
                  setreset={setreset}
                />}
              </div>
            </div>
          </div>
        </div>
      </div>
      {!noResultImage ? (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className={styles.demandDataBody}>
                <div className={styles.scrollableTable}>
                  {loader ? <Loader /> : null}
                  <table>
                    <thead>
                      <tr>
                        {_get(
                          props,
                          "data[0].component.content.field_table_labels",
                          []
                        ).map((item) => {
                          if (item != "Process ID"){
                            return <th>{item}</th>;
                          }
                          else {
                            return null
                          }
                          
                        })}
                        {/* <th>Process Id</th>
                <th>Process Name</th>
                <th>Process Description</th>
                <th>Lead Platform</th>
                <th>Area</th>
                <th>SubArea</th>
                <th>country</th>
                <th>Requester Email Id</th>
              <th>Engagement Lead</th>

                <th>First Level Gfcf Approver</th>
                <th>First Level Gfcf Approval Date</th>
                <th>First Level Gfcf Approval Status</th>
                <th>First Level Gfcf Comment</th>
                <th>Second Level Gfcf Approver</th>
                <th>Second Level Gfcf Approval Date</th>
                <th>Second Level Gfcf Approval Status</th>
                <th>Second Level Gfcf Comment</th>

                <th>First Level Gpm Approver</th>
                <th>First Level Gpm Approval Date</th>
                <th>First Level Gpm Approval Status</th>
                <th>First Level Gpm Approval Comment</th>
                <th>Second Level Gpm Approver</th>
                <th>Second Level Gpm Approval Date</th>
                <th>Second Level Gpm Approval Status</th>
                <th>Second Level Gpm Approval Comment</th>
                <th>GCAD Approver</th>
                <th>GCAD Approval Date</th>
                <th>GCAD Approval Status</th>
                <th>GCAD Approval Comment</th>
                <th>Business Owner Comments</th> */}
                      </tr>
                    </thead>

                    {isTabletOrMobile ? (
                      <tbody>
                        {botState.map((item, index) => (
                          <tr>
                            <td>
                              <div>{item.botExternalId}</div>
                            </td>
                          
                            <td>
                              <div>
                                <a
                                target="_blank"
                                 className={styles.processName}
                                  href = {`${endpoints.redirectUriLogin}botDetails?botID=${item.botExternalId}`}
                                >
                                  {item.processName}
                                </a>
                              </div>
                            </td>
                            <td>
                              <div>{item.processDescription}</div>
                            </td>
                            {/* {item.processDescription.length > 30 ? 
                  
                  readMoreState[index] == true ? 
                  <td>{ item.processDescription } <button onClick = {() => {setReadMoreState({...readMoreState, [index] : false})}}>Read Less</button></td>
                  :
                  <td>{item.processDescription.slice(0, 30)+"..."} <button onClick = {() => {setReadMoreState({...readMoreState, [index] : true})}}>Read More</button> </td>
                  :
                  <td>{item.processDescription}</td>
                }  */}
                            <td>
                              <div>{item.leadPlatform}</div>
                            </td>
                            <td>
                              <div>{item.area}</div>
                            </td>
                            <td>
                              <div>{item.subArea}</div>
                            </td>
                            <td>
                              <div>{item.cluster}</div>
                            </td>
                            <td>
                              <div>
                                {item.country ? item.country.split(";").join(",") : ""}
                              </div>
                            </td>
                            <td>
                              <div>
                                 {item.landscapeId}
                                {(item.landscapeId!=="" && item.landscapeId!==undefined && item.landscapeId!==null) ? getLandscapeById(item.landscapeId): ""}
                              </div>
                            </td>
                            <td>
                              <div>
                                {item.requesterEmailID == "NA"
                                  ? ""
                                  : item.requesterEmailID}
                              </div>
                            </td>
                            <td>
                              <div>
                                {item.engagementLead == "NA"
                                  ? ""
                                  : item.engagementLead}
                              </div>
                            </td>
                            <td>
                              <div>
                                {item.status == "NA" ? "" : item.status}
                              </div>
                            </td>
                            <td>
                              <div>{item.firstLevelgfcfApprover}</div>
                            </td>
                            <td>
                              <div>
                                {item.firstLevelGfcfApprovalDate == "2018-12-31" || item.firstLevelGfcfApprovalDate == "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.firstLevelGfcfApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {
                                     item.firstLevelgfcfApprovalStatus
                                    ? "Approved" : item.firstLevelgfcfApprovalStatus === false ?
                                     "Rejected" : ""
                                }
                              </div>
                            </td>
                            <td>
                              <div>{item.firstLevelGfcfComment}</div>
                            </td>

                            <td>
                              <div>{item.secondLevelGfcfApprover}</div>
                            </td>
                            <td>
                              <div>
                                {item.secondLevelGfcfApprovalDate ==
                                "2018-12-31" || item.secondLevelGfcfApprovalDate ==
                                "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.secondLevelGfcfApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {
                                     item.secondLevelGfcfApprovalStatus
                                    ? "Approved" : item.secondLevelGfcfApprovalStatus === false ?
                                     "Rejected" : ""
                                  }
                              </div>
                            </td>
                            <td>
                              <div>{item.secondLevelGfcfComment}</div>
                            </td>

                            <td>
                              <div>{item.firstLevelGpmApprover}</div>
                            </td>
                            <td>
                              <div>
                                {item.firstLevelGpmApprovalDate == "2018-12-31" || item.firstLevelGpmApprovalDate == "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.firstLevelGpmApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {
                                    item.firstLevelGpmApprovalStatus
                                    ? "Approved" :  item.firstLevelGpmApprovalStatus === false
                                    ?
                                     "Rejected" : ""
                                }
                              </div>
                            </td>
                            <td>
                              <div>{item.firstLevelGpmComment}</div>
                            </td>

                            <td>
                              <div>{item.secondLevelGpmApprover}</div>
                            </td>
                            <td>
                              <div>
                                {item.secondLevelGpmApprovalDate == "2018-12-31" || item.secondLevelGpmApprovalDate == "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.secondLevelGpmApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {
                                     item.secondLevelGpmApprovalStatus
                                    ? "Approved":  item.secondLevelGpmApprovalStatus === false
                                    ?
                                     "Rejected"
                                  : ""}
                              </div>
                            </td>
                            <td>
                              <div>{item.secondLevelGpmComment}</div>
                            </td>
                            <td>
                              <div>{item.gcadApprover}</div>
                            </td>
                            <td>
                              <div>
                                {item.gcadApprovalDate == "2018-12-31" || item.gcadApprovalDate == "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.gcadApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {
                                     item.gcadApprovalStatus
                                    ? "Approved"
                                    : item.gcadApprovalStatus === false
                                    ? "Rejected"
                                  : ""}
                              </div>
                            </td>
                            <td>
                              <div>{item.gcadComments}</div>
                            </td>
                            <td>
                              <div>{item.businessOwnerComments}</div>
                            </td>
                            <td>
                              <div>{item.landscapeApprovers}</div>
                            </td>
                            <td>
                              <div>
                                {item.landscapeApprovalDate == "2018-12-31" || item.landscapeApprovalDate == "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.landscapeApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {
                                     item.landscapeApprovalStatuss
                                    ? "Approved"
                                    : item.landscapeApprovalStatuss === false
                                    ? "Rejected"
                                  : ""}
                              </div>
                            </td>
                            <td>
                              <div>{item.landscapeComments}</div>
                            </td>
                            <td>
                              <div>{item.infosecApprovers}</div>
                            </td>
                            <td>
                              <div>
                                {item.infosecApprovalDate == "2018-12-31" || item.infosecApprovalDate == "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.infosecApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {
                                     item.infosecApprovalStatuss
                                    ? "Approved"
                                    : item.infosecApprovalStatuss === false
                                    ? "Rejected"
                                  : ""}
                              </div>
                            </td>
                            <td>
                              <div>{item.infosecComments}</div>
                            </td>
                            <td>
                              <div>{item?.controlActivityType}</div>
                            </td>
                            <td>
                              <div>{item?.controlNumber}</div>
                            </td>
                            
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <tbody>
                        {botState.map((item, index) => (
                          <tr>
                            <td>
                              <div>{item.botExternalId}</div>
                            </td>
                         
                            <td>
                              <div>
                              <a
                                target="_blank"
                                  className={styles.processName}
                                  href = {`${endpoints.redirectUriLogin}botDetails?botID=${window.btoa(item.botID)}`}
                                >
                                  {item.processName}
                                </a>
                              </div>
                            </td>
                            <td>
                              <div>{item.processDescription}</div>
                            </td>
                            {/* {item.processDescription.length > 30 ? 
                  
                  readMoreState[index] == true ? 
                  <td>{ item.processDescription } <button onClick = {() => {setReadMoreState({...readMoreState, [index] : false})}}>Read Less</button></td>
                  :
                  <td>{item.processDescription.slice(0, 30)+"..."} <button onClick = {() => {setReadMoreState({...readMoreState, [index] : true})}}>Read More</button> </td>
                  :
                  <td>{item.processDescription}</td>
                }  */}
                            <td>
                              <div>{item.leadPlatform}</div>
                            </td>
                            <td>
                              <div>{item.area}</div>
                            </td>
                            <td>
                              <div>{item.subArea}</div>
                            </td>
                            <td>
                              <div>{item.cluster}</div>
                            </td>
                            <td>
                              <div>
                                {item.country
                                  .replaceAll(";", ",")
                                  .substring(0, item.country.length)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {item.requesterEmailID == "NA"
                                  ? ""
                                  : item.requesterEmailID}
                              </div>
                            </td>
                            <td>
                              <div>
                                {item.engagementLead == "NA"
                                  ? ""
                                  : item.engagementLead}
                              </div>
                            </td>
                            <td>
                              <div>
                                {item.status == "NA" ? "" : item.status}
                              </div>
                            </td>
                            <td>
                              <div>
                              
                                {(item.landscapeId!=="" && item.landscapeId!==undefined && item.landscapeId!==null) ? getLandscapeById(item.landscapeId): ""}
                              </div>
                            </td>
                            <td>
                              <div>{item.firstLevelgfcfApprover}</div>
                            </td>
                            <td>
                              <div>
                                {item.firstLevelGfcfApprovalDate == "2018-12-31"  || item.firstLevelGfcfApprovalDate == "2018-12-30"
                                ||   item.firstLevelGfcfApprovalDate ==
                                "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.firstLevelGfcfApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {
                                  
                                     item.firstLevelgfcfApprovalStatus
                                    ? "Approved"
                                    : item.firstLevelgfcfApprovalStatus === false ? "Rejected"
                                  : ""}
                              </div>
                            </td>
                            <td>
                              <div>{item.firstLevelGfcfComment}</div>
                            </td>

                            <td>
                              <div>{item.secondLevelGfcfApprover}</div>
                            </td>
                            <td>
                              <div>
                                {item.secondLevelGfcfApprovalDate ==
                                "2018-12-31" || item.secondLevelGfcfApprovalDate ==
                                "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.secondLevelGfcfApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {
                                   
                                     item.secondLevelGfcfApprovalStatus
                                    ? "Approved"
                                    : item.secondLevelGfcfApprovalStatus === false ? "Rejected"
                                  : ""}
                              </div>
                            </td>
                            <td>
                              <div>{item.secondLevelGfcfComment}</div>
                            </td>

                            <td>
                              <div>{item.firstLevelGpmApprover}</div>
                            </td>
                            <td>
                              <div>
                                {item.firstLevelGpmApprovalDate == "2018-12-31" || item.firstLevelGpmApprovalDate ==
                                  "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.firstLevelGpmApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {
                                  
                                    item.firstLevelGpmApprovalStatus
                                    ? "Approved"
                                    : item.firstLevelGpmApprovalStatus === false ? "Rejected"
                                  : ""}
                              </div>
                            </td>
                            <td>
                              <div>{item.firstLevelGpmComment}</div>
                            </td>

                            <td>
                              <div>{item.secondLevelGpmApprover}</div>
                            </td>
                            <td>
                              <div>
                                {item.secondLevelGpmApprovalDate == "2018-12-31" || item.secondLevelGpmApprovalDate ==
                                  "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.secondLevelGpmApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                { 
                                    item.secondLevelGpmApprovalStatus
                                    ? "Approved" 
                                    :  item.secondLevelGpmApprovalStatus === false ? "Rejected"
                                  : ""}
                              </div>
                            </td>
                            <td>
                              <div>{item.secondLevelGpmComment}</div>
                            </td>
                            <td>
                              <div>{item.gcadApprover}</div>
                            </td>
                            <td>
                              <div>
                                {item.gcadApprovalDate == "2018-12-31" || item.gcadApprovalDate ==
                                  "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.gcadApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {
                                 
                                    item.gcadApprovalStatus
                                    ? "Approved" 
                                    : item.gcadApprovalStatus === false ? "Rejected"
                                  : ""}
                              </div>
                            </td>
                            <td>
                              <div>{item.gcadComments}</div>
                            </td>
                            <td>
                              <div>{item.businessOwnerComments}</div>
                            </td>
			   <td>
                              <div>{item.landscapeApprovers}</div>
                            </td>
                            <td>
                              <div>
                                {item.landscapeApprovalDate == "2018-12-31" || item.landscapeApprovalDate == "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.landscapeApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {
                                     item.landscapeApprovalStatuss
                                    ? "Approved"
                                    : item.landscapeApprovalStatuss === false
                                    ? "Rejected"
                                  : ""}
                              </div>
                            </td>
                            <td>
                              <div>{item.landscapeComments}</div>
                            </td>
                            <td>
                              <div>{item.infosecApprovers}</div>
                            </td>
                            <td>
                              <div>
                                {item.infosecApprovalDate == "2018-12-31" || item.infosecApprovalDate == "2018-12-30"
                                  ? ""
                                  : convertToDDMMYYYY(item.infosecApprovalDate)}
                              </div>
                            </td>
                            <td>
                              <div>
                                {
                                     item.infosecApprovalStatuss
                                    ? "Approved"
                                    : item.infosecApprovalStatuss === false
                                    ? "Rejected"
                                  : ""}
                              </div>
                            </td>
                            <td>
                              <div>{item.infosecComments}</div>
                            </td>
                            <td>
                              <div>{item?.controlActivityType}</div>
                            </td>
                            <td>
                              <div>{item?.controlNumber}</div>
                            </td>                           
                          </tr>
                        ))}
                      </tbody>
                    )}
                  </table>
                </div>
                <div className={styles.fixedTable}>
                  {loader ? <Loader /> : null}
                  <table>
                    <thead>
                      <tr>
                        {approvers.includes(auth.userType) && <th>Actions</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {botState.map((item, index) => (
                        <tr className={styles.actionMobile}>
                          {approvers.includes(auth.userType) && (
                            <td
                              onClick={() => {
                                {
                                  router.push({
                                    pathname: "/approvalForm",
                                    query: {
                                      botID:  window.btoa(item.botID),
                                    },
                                  });
                                }
                              }}
                            >
                              <div>
                                <Icons
                                  name="pencilDark"
                                  className={styles.editInactive}
                                />
                              </div>
                            </td>
                          )}
                        </tr>
                      ))}
                      {botState.map((item, index) => (
                        <tr className={styles.actionDesktop}>
                          {approvers.includes(auth.userType) && (
                            <td
                              onClick={() => {
                                {
                                  router.push({
                                    pathname: "/approvalForm",
                                    query: {
                                      botID: window.btoa(item.botID),
                                    },
                                  });
                                }
                              }}
                            >
                              <div>
                                <Icons
                                  name="pencilDark"
                                  className={styles.editInactive}
                                />
                              </div>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.noresults}>
          <img
            src={`${endpoints.drupalIp}${_.get(
              props.data[1].component.content,
              "field_no_result_image[0].file_url",
              ""
            )}`}
          />
          <h3 className={styles.head}>
            {" "}
            {_.get(props.data[1].component.content, "field_title", "")}
          </h3>
          <div
            className={styles.content}
            dangerouslySetInnerHTML={{
              __html: _.get(
                props.data[1].component.content,
                "field_details",
                ""
              ),
            }}
          ></div>
        </div>
      )}
      <div
        className={styles.mobileFilterBtn}
        onClick={() => setFilterActive(true)}
      >
        <span className={styles.btn}>
          <Icons name="filters" className={styles.filterIcon} />
          Filters
          <sup className={styles.filterCount}>{length > 4 ? 4 : length}</sup>
        </span>
      </div>

      {botCount > 0 ? (
        <Pagination
          totalLength={botCount}
          paginationNum={paginationNum}
          setPaginationNum={setPaginationNum}
        />
      ) : null}

      {filterActive ? (
        <MobileFilters
          filterMobileData={filterDropdowns}
          setState={setFilterState}
          setFilterActive={setFilterActive}
          previousState={filterState}
          mobileFilterRelatedInfo={mobileFilterRelatedInfo}
          setMobileFilterRelatedInfo={setMobileFilterRelatedInfo}
          setLength={setLength}
          length={length}
          setFilterOn={setFilterOn}
          initialState={{kfa : true}}
        />
      ) : null}
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);

